import { render, staticRenderFns } from "./ContentDetailPackage.vue?vue&type=template&id=7a48881a"
import script from "./ContentDetailPackage.js?vue&type=script&lang=js&external"
export * from "./ContentDetailPackage.js?vue&type=script&lang=js&external"
import style0 from "./ContentDetailPackage.vue?vue&type=style&index=0&id=7a48881a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports